import React from 'react'


const EmotionNormal = (props) =>
<svg {...props} viewBox="0 0 1000 1000" xmlns="http://www.w3.org/2000/svg"><path d="M500 789c-77.2 0-149.8-30.1-204.4-84.6C241.1 649.8 211 577.2 211 500s30.1-149.8 84.6-204.4C350.2 241.1 422.8 211 500 211s149.8 30.1 204.4 84.6C758.9 350.2 789 422.8 789 500s-30.1 149.8-84.6 204.4C649.8 758.9 577.2 789 500 789zm0-538c-137.3 0-249 111.7-249 249s111.7 249 249 249 249-111.7 249-249-111.7-249-249-249z"/><path d="M347.5 480h305v40h-305zM347.5 390h74.2v40h-74.2zM578.3 390h74.2v40h-74.2z"/></svg>

export default EmotionNormal


// WEBPACK FOOTER //
// ./src/components/_common/_icons/EmotionNormal.js